import _ from 'lodash'
import Vue from '../../lib/utils/vue'
import VueI18n from 'vue-i18n'
import { styled, VueEmotion } from '@egoist/vue-emotion'
import * as getters from '../../../builder/src/js/store/modules/getters'
import * as actions from '../../../builder/src/js/store/modules/actions'
import * as mutations from '../../../builder/src/js/store/modules/mutations'
import { PopUpMarketplace, V1PopupSite } from '../../../builder/src/js/store/services/api'
import { mapGetters, mapState, mapActions, mapMutations } from 'vuex'
import { CvtSiteThumbnailAndActions } from '../organisms/right-sidebar/site-thumbnail-and-actions'
import { CvtUrlRadioButtonActions } from '../organisms/right-sidebar/url-radio-button-actions'
import { LEFT_SIDEBAR_STANDARD } from '../constants'
import { CvtAnalyticsSidebar } from '../organisms/right-sidebar/analytics-sidebar'
import { CvtPopupLeftNavBar } from '../organisms/popup-left-nav'
import { CvtPopupSearchFilter } from '../organisms/popup-search'
import { CvtPopupListItem } from '../organisms/popup-list-item'
import { CvtMarketplaceCard } from '../organisms/marketplace-card'
import CvtLoadingMessage from '../molecules/LoadingMessage'

const popupSiteAPI = new V1PopupSite()
const popupMarketplace = new PopUpMarketplace()

Vue.use(VueEmotion)
Vue.use(VueI18n)

let Spacing,
  Radii,
  Border,
  Colors,
  textLineHeight,
  BorderStyle,
  textFontWeight,
  borderColor,
  backgroundColor,
  textFontSize,
  textColor,
  FontFamily

const getContentWrap = () => styled('div')`
  display: flex;
  justify-content: space-between;
  height: 100vh;
`

const getPopupLeftNavBarWrap = () => styled('div')`
  position: fixed;
  top: 64px;
`

const getMarketplaceTemplateGroupAlt = () => styled('div')`
  background-color: #fff;
  overflow-y: inherit;
  overflow-x: hidden;
  margin-top: 30px;
  width: 100%;
  padding: 3% 0% 3% 320px;

  @media (max-width: 768px) {
    padding: 3% 0% 3% 150px;
  }
`

const getMarketplaceCard = () => styled(CvtMarketplaceCard)`
  width: 320px !important;
  height: 240px !important;

  > div > div {
    border: 1px solid #f0f2f6;
    width: 320px;
    height: 240px;
    background-color: #fff;
    border-radius: 7px;

    button {
      border-radius: 0px !important;
    }
  }
`

const getMarketplaceTemplate = () => styled('div')`
  margin-top: 70px;
`

const getMarketplaceTemplates = () => styled('div')`
  margin: 0 auto;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
`

const getSearchFilter = () => styled(CvtPopupSearchFilter)`
  position: fixed;
  width: calc(100vw - 320px);
  z-index: 2;
  top: 64px;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    width: calc(100vw - 150px);
  }
`

export const CvtPopupChooseTemplate = {
  name: 'CvtPopupChooseTemplate',
  components: {
    CvtSiteThumbnailAndActions,
    CvtUrlRadioButtonActions,
    CvtAnalyticsSidebar,
  },
  data() {
    return {
      locked: false,
      yourPopups: {
        id: 'your-popups',
        label: this.$t('marketplace.left_side_bar.popups.your_popups'),
      },
      archivedPopups: {
        id: 'archived-popups',
        label: this.$t('marketplace.left_side_bar.popups.archive_popups'),
      },
      showOverlayOn: null,
      previewTemplatId: null,
      enter: {
        duration: 800,
        opacity: 1,
        easing: 'easeInOutQuart',
      },
      leave: {
        duration: 800,
        opacity: 0,
        easing: 'easeInOutQuart',
      },
      beforeEnter(e) {
        e.style.opacity = 0
      },
      yourPopupsList: [],
      yourPopupsListAll: [],
      archivedPopupsList: [],
      yourPopupsSitesListAll: [],
      marketplacePagination: { limit: 5, offset: 0 },
      archivedPopupsPagination: { limit: 5, offset: 0 },
      personalPopupsPagination: { limit: 10, offset: 0 },
      personalPopupsSitesPagination: { limit: 1000, offset: 0 },
      loading: true,
      showArchiveDialog: false,
      archivePopup: null,
      archiving: false,
      templatesCount: {},
      searchQuery: '',
      isCreatedSelected: false,
      isLastUpdatedSelected: false,
      isPublished: false,
      filterToEcommerce: false,
      isRightSidebarVisible: null,
      selectedPopup: null,
      selectedPopupSite: null,
      templatesViewFormat: null,
    }
  },
  props: {
    mode: {
      type: String,
      default: 'LIGHT',
    },
  },
  computed: {
    ...mapGetters({
      marketplacePopups: getters.POPUP_MARKETPLACE_TEMPLATES,
      config: getters.AUTH_GET_USER_CONFIG,
    }),
    ...mapState('route', {
      query: (state) => state.query,
    }),
    ...mapState('globalTheme', {
      globalTheme: ({ globalTheme }) => globalTheme,
      topNavConfig: ({ topNavConfig }) => topNavConfig,
      leftNavConfig: ({ leftNavConfig }) => leftNavConfig,
      marketplaceConfig: ({ marketplaceConfig }) => marketplaceConfig,
      iconConfig: ({ iconConfig }) => iconConfig,
      leftNavType: ({ iconConfig }) =>
        iconConfig?.marketplaceCategories?.theme || 'standard',
      leftNavItemsAllPopupsText: ({ leftNavConfig }) =>
        leftNavConfig.marketplace.navItems.allTemplatesText.text,
      StartFromScratchHover: ({ globalTheme }) =>
        globalTheme.StartFromScratchHover !== undefined
          ? globalTheme.StartFromScratchHover
          : true,
      ShowCount: ({ globalTheme }) =>
        globalTheme.ShowCount !== undefined ? globalTheme.ShowCount : true,
      orgName: ({ globalTheme }) =>
        globalTheme?.OrgName !== undefined
          ? globalTheme.OrgName
          : LEFT_SIDEBAR_STANDARD,
      activeCategory: ({ activeCategory }) => activeCategory,
    }),
    cardType() {
      return this.yourPopupsActive
        ? ''
        : this.archivedPopupsActive
        ? 'archivedTemplate'
        : ''
    },
    isGridBuilder() {
      return this.config.GRID_BUILDER_ENABLED === true
    },
    yourPopupsActive() {
      return this.activeCategory === this.yourPopups.id
    },
    archivedPopupsActive() {
      return this.activeCategory === this.archivedPopups.id
    },
    allTemplateActive() {
      return this.activeCategory === null
    },
    filteredPopups() {
      if (this.yourPopupsActive) {
        return this.yourPopupsList
      }
      if (this.archivedPopupsActive) {
        return this.archivedPopupsList
      }
      return _.chain(this.marketplacePopups)
        .filter((t) => {
          return this.activeCategory
            ? _.includes(
                t.categories.map((c) => c.id),
                this.activeCategory,
              )
            : true
        })
        .value()
    },
    filteredCategories() {
      return this.categories.filter(
        (category) => category.id == null || category.id !== undefined,
      )
    },
    categories() {
      const _categories = [
        {
          id: null,
          label: this.$t('marketplace.left_side_bar.popups.all_templates'),
        },
        {
          id: 'lead_gen',
          label: this.$t('marketplace.left_side_bar.popups.lead_generation'),
        },
        {
          id: 'promotion',
          label: this.$t('marketplace.left_side_bar.popups.promotion'),
        },
        {
          id: 'newsletter_signup',
          label: this.$t('marketplace.left_side_bar.popups.newsletter_and_sign_up'),
        },
        this.yourPopups,
        this.archivedPopups,
      ]
      if (this.config.ECOMMERCE && this.filterToEcommerce) {
        //TODO: will manage ECOMMERCE config - verify if this required from Dhruv
        return _categories.filter((i) => i !== null)
      }
      return _categories.filter((i) => i !== null)
    },
    moreActions() {
      return []
    },
    isTemplateActionsRightSidebarEnabled() {
      return this.config.TEMPLATE_ACTIONS_RIGHT_SIDEBAR === true
    },
    copyOrEditPageButton() {
      if (this.marketplaceConfig.marketplaceCard.swapTemplateButtonAction) {
        return this.marketplaceConfig.marketplaceCard.editPageButton
      }
      return this.marketplaceConfig.marketplaceCard.copyPageButton
    },
    isTabsUiEnabled() {
      return this.config.CHOOSE_A_TEMPLATE_TABS_UI === true
    },
  },
  async created() {
    // Set configurations for tenants if they exist
    this.config.GLOBAL_THEME ? this.setTheme(this.config.GLOBAL_THEME) : false
    this.config.TOP_NAV_CONFIG ? this.setTopNavConfig(this.config.TOP_NAV_CONFIG) : false
    this.config.LEFT_NAV_CONFIG ? this.setLeftNavConfig(this.config.LEFT_NAV_CONFIG) : false
    this.config.MARKETPLACE_CONFIG ? this.setMarketplaceConfig(this.config.MARKETPLACE_CONFIG) : false
    this.config.ICON_CONFIG ? this.setIconConfig(this.config.ICON_CONFIG) : false
    const { categories = '' } = this.query
    this.filterToEcommerce = categories.includes('e-commerce')
    await this.loadMoreMarketplacePopups()
    await this.loadMoreArchivedPopups()
    await this.loadMorePersonalPopups()
    this.templatesCount = await popupMarketplace
      .countPopupTemplate({})
      .then(({ data }) => data)
  },
  beforeDestroy() {
    this.resetRightSideBarVariables()
  },
  methods: {
    ...mapActions({
      createSiteFromTemplate: actions.POPUP_MARKETPLACE_CREATE_SITE_FROM_TEMPLATE,
      openPreviewWindow: actions.PAGE_PREVIEW_TOGGLE,
      archiveSite: actions.SITE_ARCHIVE,
      restoreSite: actions.SITE_RESTORE,
      loadMarketplacePopups: actions.POPUP_MARKETPLACE_LOAD_TEMPLATES,
      mixpanelTrack: actions.MIXPANEL_TRACK,
      templateFetchData: actions.TEMPLATE_FETCH_DATA,
      loadDomains: actions.MARKETPLACE_LOAD_DOMAINS,
      disconnectDomain: actions.CUSTOM_DOMAIN_DISCONNECT,
    }),
    ...mapMutations({
      hideEditorNameDialog: mutations.HIDE_EDITOR_NAME_DIALOG,
      showEditorNameDialog: mutations.SHOW_EDITOR_NAME_DIALOG,
      updateDomains: mutations.MARKETPLACE_UPDATE_DOMAINS,
    }),
    ...mapActions('globalTheme', {
      setTheme: 'setTheme',
      setTopNavConfig: 'setTopNavConfig',
      setLeftNavConfig: 'setLeftNavConfig',
      setMarketplaceConfig: 'setMarketplaceConfig',
      setIconConfig: 'setIconConfig',
      setActiveCategory: 'setActiveCategory',
    }),
    copyPopupBtnClicked(popup) {
      this.showPreviewWindow(popup.id)
    },
    editSiteBtnClicked(popup) {
      this.editSite(popup)
    },
    archivePopupBtnClicked(popup) {
      this.openArchivePrompt(popup)
    },
    loadMoreListItems() {
      return this.loadMorePersonalPopups
    },
    loadMorePopups() {
      if (this.yourTemplatesActive) {
        return this.loadMorePersonalPopups
      }
      if (this.archivedTemplatesActive) {
        return this.loadMoreArchivedPopups
      }
      return this.loadMoreMarketplacePopups
    },
    onSearchDone(searchQuery) {
      this.searchQuery = searchQuery

      this.resetAndLoadYourPages()
    },
    onSortParameter(sortMethod, isSorted) {
      if (sortMethod === 'created') {
        this.isCreatedSelected = isSorted
        if (this.isCreatedSelected) {
          this.isLastUpdatedSelected = false
        }
      } else if (sortMethod === 'lastUpdated') {
        this.isLastUpdatedSelected = isSorted
        if (this.isLastUpdatedSelected) {
          this.isCreatedSelected = false
        }
      } else if (sortMethod === 'published') {
        const popupsArr = [...this.yourPopupsList]
        this.isPublished = isSorted
        if (isSorted) {
          const filteredPopupups = popupsArr.filter(
            (popup) => popup.state.toLowerCase() === 'unpublished'
          )
          return (this.yourPopupsList = filteredPopupups)
        }
        return (this.yourPopupsList = this.yourPopupsListAll)
      }

      this.resetAndLoadYourPages()
    },

    resetAndLoadYourPages() {
      this.personalPopupsPagination.offset = 0
      this.yourPopupsListAll = []
      this.yourPopupsList = []

      this.loadMorePersonalPopups()
    },
    async restoreArchivedPopup(popup) {
      await this.restoreSite(popup.id)
      const { id, name } = popup

      this.archivedPopupsList = this.archivedPopupsList.filter((t) => t.id !== id)
      this.yourPopupsList.unshift(popup)
      this.$message({ type: 'info', message: `Restored: ${name}` })
    },
    onMoreActionClicked(actionName, template) {
      if (actionName === 'copy-template') this.showPreviewWindow(template.id)
      else if (actionName === 'edit-template') this.editSite(template)
      else if (actionName === 'archive') this.openArchivePrompt(template)
    },
    getStartFromScratchClass() {
      return {
        'marketplace-templates--noMoreActions':
          this.yourPopupsActive || this.archivedPopupsActive,
      }
    },
    async startFromScratch() {
      console.debug('clicked start from scratch')
      if (this.locked) {
        console.debug('start from scratch is locked')
        console.error(
          'You already clicked this once... something went wrong. If you are having issues refresh your browser and try again.',
        )
        return
      }
      this.locked = true
      try {
        const { data } = await this.createSiteFromTemplate()
        this.showEditorNameDialog()
        this.$router.push({
          name: 'popup:editor:design',
          params: {
            popupId: data.id,
          },
        })
      } catch (err) {
        this.hideEditorNameDialog()
        this.locked = false
        throw err
      }
    },
    selectCategory(cat) {
      this.setActiveCategory(cat.id)
      this.resetRightSideBarVariables()
      this.resetTemplateViewFormat()
    },
    resetRightSideBarVariables() {
      this.isRightSidebarVisible = null
      this.selectedPopup = null
      this.selectedPopupSite = null
    },
    resetTemplateViewFormat() {
      this.templatesViewFormat = null
    },
    fmtGroupName(id) {
      id = id || 1
      return _.chain(this.categories).find({ id }).get('label').value()
    },
    overlayIsActive(templateId) {
      return this.showOverlayOn === templateId
    },
    disableOverlay() {
      this.showOverlayOn = null
    },
    activateOverlay(templateId) {
      this.showOverlayOn = templateId
    },
    showPreviewWindow(templateId) {
      this.previewTemplatId = templateId
      this.templateFetchData(templateId)
      this.openPreviewWindow(true)
      if (this.yourPopupsActive) {
        // TODO: mixpanelTrack
        // this.mixpanelTrack({
        //   event: 'Copy Template',
        //   category: 'templates',
        //   data: { template_id: templateId },
        // });
      } else if (this.archivedPopupsActive) {
        // TODO: mixpanelTrack
        // this.mixpanelTrack({
        //   event: 'Restore archived template',
        //   category: 'templates',
        //   data: { template_id: templateId },
        // });
      } else {
        // TODO: mixpanelTrack
        // this.mixpanelTrack({
        //   event: 'Use This Template',
        //   category: 'templates',
        //   data: { template_id: templateId },
        // });
      }
    },
    async useTemplate(popUpId) {
      // TODO: Remove
      console.debug('using template', popUpId)
      const { data } = await this.createSiteFromTemplate(popUpId)
      console.debug('cloned template', data)
      this.showEditorNameDialog()
      this.$router.push({
        name: 'popup:editor:design',
        params: {
          siteId: data.id,
        },
      })
      if (this.yourPopupsActive) {
        // TODO: mixpanelTrack
        // this.mixpanelTrack({
        //   event: 'Copy Template',
        //   category: 'templates',
        //   data: { popup_id: popUpId },
        // });
      } else if (this.archivedPopupsActive) {
        // TODO: mixpanelTrack
        // this.mixpanelTrack({
        //   event: 'Restore archived template',
        //   category: 'templates',
        //   data: { popup_id: popUpId },
        // });
      } else {
        // TODO: mixpanelTrack
        // this.mixpanelTrack({
        //   event: 'Use This Template',
        //   category: 'templates',
        //   data: { popup_id: popUpId },
        // });
      }
    },
    editSite(popup) {
      // TODO: mixpanelTrack
      // this.mixpanelTrack({
      //   event: 'Edit Template',
      //   category: 'templates',
      //   data: { popup_id: popup.id },
      // });
      this.$router.push({
        name: 'popup:editor:design',
        params: {
          popupId: popup.id,
        },
      })
    },
    async openArchivePrompt(popup) {
      this.showArchiveDialog = true
      this.archivePopup = popup
    },
    async onArchiveTemplate(popup) {
      const { id, name } = popup
      this.archiving = true
      await this.archiveSite(id)
      this.yourPopupsList = this.yourPopupsListAll.filter((t) => t.id !== id)
      this.archivedPopupsList.unshift(popup)
      this.$message({ type: 'info', message: `Archived: ${name}` })
      this.archivePopup = null
      this.archiving = false
      this.showArchiveDialog = false
    },
    abortTemplateArchive() {
      this.archivePopup = null
      this.showArchiveDialog = false
    },
    // This name is a bit confusing since this function
    // is the first template loading function to run...
    // it retrieves based on the pagination value so it
    // works regardless of initial or subsequent runs.
    async loadMoreMarketplacePopups() {
      try {
        this.loading = true
        await this.loadMarketplacePopups({
          ...this.marketplacePagination,
          // version: this.isGridBuilder ? 'v2' : undefined,
        })
        this.marketplacePagination.offset += this.marketplacePagination.limit
        this.loading = false
      } catch (err) {
        this.loading = false
      }
    },
    async loadMoreArchivedPopups() {
      this.loading = true
      try {
        const { data } = await popupSiteAPI.all({
          ...this.archivedPopupsPagination,
          archived: true,
        })
        this.archivedPopupsList = this.archivedPopupsList.concat(data)
        this.archivedPopupsPagination.offset +=
          this.archivedPopupsPagination.limit
        this.loading = false
      } catch (err) {
        this.loading = false
      }
    },

    async loadMorePersonalPopups() {
      let submitData = {
        ...this.personalPopupsPagination,
        market: true,
        dateCreated: this.isCreatedSelected ? 1 : 0,
        dateUpdated: this.isLastUpdatedSelected ? 1 : 0,
        isPublished: this.isPublished ? 1 : 0,
        search: this.searchQuery ? this.searchQuery.trim() : '',
      }
      try {
        this.loading = true
        const { data } = await popupSiteAPI.all(submitData)
        this.yourPopupsListAll = this.yourPopupsListAll.concat(data)
        this.personalPopupsPagination.offset +=
          this.personalPopupsPagination.limit
        this.yourPopupsList = this.yourPopupsListAll.slice(
          0,
          this.personalPopupsPagination.offset +
            this.personalPopupsPagination.limit,
        )

        //Load more sites when it will match the page
        if (
          this.personalPopupsPagination.offset >
          this.personalPopupsSitesPagination.offset
        ) {
          await this.loadMorePopups()
        }

        this.loading = false
      } catch (err) {
        this.loading = false
      }
    },
  },
  async mounted() {
    this.$store.commit(mutations.SITE_SET_DATA, this.site)
  },
  render: function (h) {
    const ContentWrap = getContentWrap()
    const PopupLeftNavBarWrap = getPopupLeftNavBarWrap()
    const MarketplaceTemplateGroupAlt = getMarketplaceTemplateGroupAlt()
    const MarketplaceTemplate = getMarketplaceTemplate()
    const MarketplaceTemplates = getMarketplaceTemplates()
    const SearchFilter = getSearchFilter()
    const MarketPlaceCard = getMarketplaceCard()

    return (
      <div>
        <PopupLeftNavBarWrap>
          <CvtPopupLeftNavBar
            usage={'landingPage'}
            type={'leftNavType'}
            navigationItems={this.filteredCategories}
            initialActiveId={this.categories[0].id}
            mode={this.mode}
            onNavItemClicked={this.selectCategory}
            count={this.templatesCount}
            ShowCount={this.ShowCount}
          />
        </PopupLeftNavBarWrap>

        <ContentWrap>
          <MarketplaceTemplateGroupAlt>
            {this.yourPopupsActive && (
              <div>
                <SearchFilter
                  mode={this.mode}
                  displayTemplateViewFormatBtn={this.isTemplateActionsRightSidebarEnabled}
                  defaultSearch={this.searchQuery}
                  searchDone={this.onSearchDone}
                  onSortParameter={this.onSortParameter}
                />

                <MarketplaceTemplate>
                  {this.filteredPopups.map((popup, idx) => (
                    <CvtPopupListItem
                      key={idx}
                      templateTitle={popup.name}
                      siteStatus={popup.state}
                      onArchiveTemplateBtnClicked={() =>this.archivePopupBtnClicked(popup)}
                      onEditSiteBtnClicked={() =>this.editSiteBtnClicked(popup)}
                      onCopyTemplateBtnClicked={() =>this.copyPopupBtnClicked(popup)}
                      onMoreActionClicked={this.onMoreActionClicked}
                    >
                    </CvtPopupListItem>
                  ))}
                </MarketplaceTemplate>
              </div>
            )}

            {this.allTemplateActive && (
              <MarketplaceTemplates>
                <MarketPlaceCard
                  mode={this.mode}
                  hover={this.StartFromScratchHover}
                  usage={"startFromScratch"}
                  id={"mpCard"}
                  getStartedButton={this.marketplaceConfig.marketplaceCard.getStartedButton}
                  onStartFromScratch={this.startFromScratch}
                >
                </MarketPlaceCard>

                {this.filteredPopups.map((popup, idx) => (
                  <MarketPlaceCard
                    key={idx}
                    mode={this.mode}
                    hover={this.StartFromScratchHover}
                    getStartedButton={this.marketplaceConfig.marketplaceCard.getStartedButton}
                    id={`mpCard ${idx}`}
                    item={popup}
                    usage={"popupMarketplace"}
                    thumbnail={popup.thumbnail}
                    thumbnailAlt={popup.name}
                    onGetStarted={() => this.useTemplate(popup.id)}
                  ></MarketPlaceCard>
                ))}
              </MarketplaceTemplates>
            )}

            <CvtLoadingMessage message={"Loading"} display={this.loading} />

          </MarketplaceTemplateGroupAlt>
        </ContentWrap>
      </div>
    )
  },
}
